import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';

import DataGridTable from '@/shared/components/dataDisplay/DataGridTable/DataGridTable';
import TableInstance from '@/shared/constants/tableInstance';
import ShippingProvider from '@/shared/types/shipping/shippingProvider.type';

import useShippingProvidersTable_v2 from './hooks/useShippingProvidersTable_v2';

type ShippingProvidersTable_v2Props = {
  refreshTableIndex: number;
  onUpdateShippingProvider: (selectedRow: ShippingProvider) => void;
  onCreateShippingProvider: () => void;
};

const ShippingProvidersTable_v2: FC<ShippingProvidersTable_v2Props> = ({
  refreshTableIndex,
  onUpdateShippingProvider,
  onCreateShippingProvider,
}) => {
  const { t } = useTranslation(['shipping', 'common']);

  const { apiRef, model, table, columns, visibilityModel, setVisibilityModel } =
    useShippingProvidersTable_v2({ refreshTableIndex });

  return (
    <div style={{ height: '80vh', width: '100%' }}>
      <DataGridTable
        getRowId={(item) => item.shipping_provider_id as string}
        columns={columns}
        rows={table.data}
        rowCount={table.totalRows}
        loading={table.isLoading}
        checkboxSelection={false}
        columnVisibilityModel={visibilityModel}
        onColumnVisibilityModelChange={setVisibilityModel}
        customProps={{
          tableInstance: TableInstance.ShippingProviders,
          apiRef,
          model,
          toolbar: {
            title: 'Shipping Providers',
            toolbarActions: (
              <>
                <Button
                  variant='contained'
                  size='large'
                  onClick={onCreateShippingProvider}
                >
                  {t('shipping:addProvider')}
                </Button>
              </>
            ),
            rowActions: [
              {
                type: 'default',
                button: {
                  label: t('common:edit'),
                  onClick: (apiRef, rowId) => {
                    const selectedRow = apiRef.current.getRow(
                      rowId || '',
                    ) as ShippingProvider;

                    onUpdateShippingProvider(selectedRow);
                  },
                },
              },
            ],
          },
        }}
      />
    </div>
  );
};

export default ShippingProvidersTable_v2;
